// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "MediumPosts-module--bx--text-truncate--end--2r_xe";
export var bxTextTruncateFront = "MediumPosts-module--bx--text-truncate--front--11xUR";
export var cardContainer = "MediumPosts-module--card-container--3KOMr";
export var image = "MediumPosts-module--image--1FLTB";